import { pushRetryableEvent } from "./utils";

const VAPID_PUBLIC_KEY =
    "BBmdHDWodyyWc-E6cv58qWvk3GeSAboINGww28AhFrDFxk5ZRbKNCFz35X2oqSEbtfvq4WL8grjnh88qMunupyQ";

const NotificationsHook = {
    mounted() {
        const button = document.getElementById("request_notification_button");

        button?.addEventListener("click", async (event) => {
            console.log("Notifications allowed button clicked", event);
            try {
                await Notification.requestPermission();
                pushRetryableEvent(this, "close_notification_modal");

                const registration = await navigator.serviceWorker.ready;
                const subscription = await registration.pushManager.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
                });
                await this.confirmSubscription(subscription);
            } catch (error) {
                console.error("Error setting up push notification:", error);
            }
        });

        const urlBase64ToUint8Array = (base64String) => {
            const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
            const base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/");

            const rawData = window.atob(base64);
            const outputArray = new Uint8Array(rawData.length);

            for (let i = 0; i < rawData.length; ++i) {
                outputArray[i] = rawData.charCodeAt(i);
            }
            return outputArray;
        };

        const handleServiceWorker = async (registration) => {
            try {
                // Ensure the service worker is fully activated
                if (!registration.active) {
                    await new Promise((resolve) => {
                        registration.addEventListener("updatefound", () => {
                            const newWorker = registration.installing;
                            newWorker.addEventListener("statechange", () => {
                                if (newWorker.state === "activated") {
                                    resolve();
                                }
                            });
                        });
                    });
                }

                // Check if pushManager is available
                if (!registration.pushManager) {
                    console.error("Push notifications are not supported by this browser");
                    return;
                }

                if (!("Notification" in window)) {
                    console.warn("Notifications are not supported by this browser");
                } else if (Notification.permission === "granted") {
                    // Drop the old subscription only once we are about to replace it.
                    // Unsubscribing up front discarded a working subscription even when
                    // permission had since been revoked and nothing would replace it.
                    const existingSubscription = await registration.pushManager.getSubscription();

                    if (existingSubscription) {
                        await existingSubscription.unsubscribe();
                    }

                    const subscription = await registration.pushManager.subscribe({
                        userVisibleOnly: true,
                        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
                    });

                    await this.confirmSubscription(subscription);
                } else if (Notification.permission !== "denied") {
                    pushRetryableEvent(this, "permission_status", { status: Notification.permission });
                }
            } catch (error) {
                console.error("Error handling service worker:", error);
            }
        };

        if ("serviceWorker" in navigator) {
            navigator.serviceWorker
                .register("/serviceWorker.js")
                .then(handleServiceWorker)
                .catch((error) => {
                    console.error("Service worker registration failed:", error);
                });
        }
    },

    // By the time we get here the browser has already committed to the new
    // subscription and thrown away the old one, so the server is the only place
    // it can still be recorded. If the socket is down -- a backgrounded PWA, a
    // deploy -- a dropped push would leave the user subscribed in the browser
    // but unknown to the server, silently receiving no notifications. Hold it
    // and re-push on rejoin instead.
    async confirmSubscription(subscription) {
        this.pendingSubscription = subscription;

        try {
            await this.pushEvent("confirm_notification_subscription", JSON.stringify(subscription));
            this.pendingSubscription = null;
        } catch (error) {
            console.warn("Could not confirm push subscription, retrying on reconnect", error);
        }
    },

    reconnected() {
        if (this.pendingSubscription) {
            this.confirmSubscription(this.pendingSubscription);
        }
    },
};

export default NotificationsHook;
